import React from 'react';
import ReactModal from 'react-modal';
import moment from 'moment';

const refreshCalendar = () => {
  setCurrentDate(prev => moment(prev).add(1, 'month'));
  setTimeout(() => {
    setCurrentDate(prev => moment(prev).subtract(1, 'month'));
  }, 100);
};

const DutyModal = ({
  isOpen,
  onClose,
  currentDate,
  calendarDates,
  staffList,
  dutyByDate,
  setDutyByDate,
}) => {
  const handleToggleDuty = (date, name) => {
    setDutyByDate((prev) => {
      const currentList = prev[date] || [];
      const updatedList = currentList.includes(name)
        ? currentList.filter((n) => n !== name)
        : [...currentList, name];
      return {
        ...prev,
        [date]: updatedList,
      };
    });
  };

  const handleSave = async () => {
    try {
      const payload = Object.entries(dutyByDate).map(([date, names]) => ({
        date,
        names,
      }));

      const res = await fetch('/api/duty-roster/batch', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      const result = await res.json();
      if (result.success) {
        // alert("✅ 值日儲存成功！");
        onClose();
      } else {
        alert("❌ 儲存失敗：" + result.message);
      }
    } catch (err) {
      console.error("儲存錯誤", err);
      alert("❌ 系統錯誤，請稍後再試");
    }
  };

  // 假設隊長是名字中含「隊」字者，或依你需求調整
  const leaderList = staffList.filter(s => s.shift === '' && s.name.includes('隊'));
  const chunkDates = (dates, size = 2) => {
    const result = [];
    for (let i = 0; i < dates.length; i += size) {
      result.push(dates.slice(i, i + size));
    }
    return result;
  };

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      ariaHideApp={false}
      className="bg-white rounded-lg p-3 max-w-2xl mx-auto mt-10 shadow-xl w-[90%] sm:w-[90%]"
      overlayClassName="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50 overflow-auto"
    >
      <h2 className="text-xl font-bold text-teal-800 mb-4">設定分隊長值日</h2>

      <div className="space-y-1 max-h-[65vh] overflow-y-auto">
        {chunkDates(calendarDates, 3).map((group, rowIdx) => (
          <div key={rowIdx} className="flex gap-1">
            {group.map((dateStr) => {

              return (
                <div
                  key={dateStr}
                  onClick={(e) => {
                    e.preventDefault(); // ✅ 防止 checkbox 觸發兩次
                    const isSelected = (dutyByDate[dateStr]?.length || 0) > 0;
                    setDutyByDate(prev => ({
                      ...prev,
                      [dateStr]: isSelected ? [] : leaderList.map(p => p.name),
                    }));
                  }}
                  className={`flex-1 border rounded p-2 cursor-pointer transition 
                            ${((dutyByDate[dateStr]?.length || 0) > 0) ? 'bg-blue-200' : 'bg-white'} 
                            hover:bg-blue-50 active:bg-blue-200`}
                >
                  <div className="flex items-center gap-1 font-semibold text-sm text-gray-800">
                    <input
                      type="checkbox"
                      checked={(dutyByDate[dateStr]?.length || 0) > 0}
                      readOnly // ✅ 防止觸發 onChange，改由外層控制
                    />
                    {moment(dateStr).format('MM/DD (dd)')}
                  </div>
                </div>
              );
            })}
          </div>
        ))}
      </div>

      <div className="flex justify-end gap-2 mt-6">
        <button
          onClick={onClose}
          className="px-4 py-2 rounded bg-gray-300 hover:bg-gray-400 text-sm"
        >
          取消
        </button>
        <button
          onClick={handleSave}
          className="px-4 py-2 rounded bg-teal-600 hover:bg-teal-700 text-white text-sm"
        >
          儲存
        </button>
      </div>
    </ReactModal>
  );
};

export default DutyModal;
